/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useCallback,
  useRef,
  CSSProperties,
  memo,
  useState,
  useEffect,
} from 'react';

import { BiVideo } from 'react-icons/bi';
import { IoCloseSharp } from 'react-icons/io5';

import { useLoading } from '~/hooks/loading';
import { ExerciseService } from '~/services';

import Button from '../Button';

import * as S from './styles';

type TAlignModal = 'flex-start' | 'center' | 'flex-end';
type ExLibraryModalType = 'addCategory' | 'addCategoryExercise';

type TScrollView = boolean;

interface IModalProps {
  isRegisteringExercise?: boolean;
  modalVisible: boolean;
  setModalVisible(param: boolean): void;
  alignModal?: TAlignModal;
  scrollView?: TScrollView;
  containerStyle?: CSSProperties;
  title?: string;
  modalType: ExLibraryModalType;
  categoryName?: string;
}

export const ExLibraryModal = memo(
  ({
    isRegisteringExercise = false,
    modalVisible = false,
    alignModal = 'center',
    scrollView = false,
    setModalVisible,
    title,
    containerStyle,
    modalType,
    categoryName,
  }: IModalProps): JSX.Element => {
    const { setLoading } = useLoading();

    const backdrop = useRef<HTMLDivElement>(null);
    const [newSegment, setNewSegment] = useState<string>(categoryName || '');
    const [newExercise, setNewExercise] = useState<string>();
    const [addVideo, setAddVideo] = useState<boolean>(false);
    const [videoUrl, setVideoUrl] = useState<string>('');
    const [videoDescription, setVideoDescription] = useState<string>('');

    const handleModalVisible = useCallback(
      (e) => {
        if (e.target === backdrop.current) {
          setModalVisible(!modalVisible);
        }
      },
      [modalVisible, setModalVisible],
    );

    const handleClick = useCallback(async () => {
      setLoading(true);

      if (modalType === 'addCategory') {
        await ExerciseService.createExercise({
          muscle_segment: newSegment,
        });
        setModalVisible(!modalVisible);
      }

      if (modalType === 'addCategoryExercise') {
        await ExerciseService.createExercise({
          muscle_segment: newSegment,
          name: newExercise,
          video_url: videoUrl,
          video_description: videoDescription,
        });
        setModalVisible(!modalVisible);
      }

      setLoading(false);
    }, [
      setLoading,
      modalType,
      newSegment,
      setModalVisible,
      modalVisible,
      newExercise,
      videoUrl,
      videoDescription,
    ]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const regex = new RegExp('^(https?://)?(www.)?(youtube.com|youtu.be)/.+');

      const newValue = e.target.value;

      if (regex.test(newValue)) {
        setVideoUrl(e.target.value);
      }
    };

    useEffect(() => {
      if (!modalVisible) {
        setAddVideo(false);
        setVideoUrl('');
        setVideoDescription('');
        setNewExercise('');
      }
    }, [modalVisible]);

    return (
      <>
        <S.BackdropContainer
          ref={backdrop}
          visible={modalVisible}
          alignModal={alignModal}
          onClick={handleModalVisible}
        >
          <S.Container
            alignModal={alignModal}
            scrollView={scrollView}
            style={containerStyle}
          >
            <S.Header>
              <S.HeaderTitle>{title}</S.HeaderTitle>
              <IoCloseSharp
                style={{ cursor: 'pointer' }}
                size={30}
                onClick={() => setModalVisible(!modalVisible)}
              />
            </S.Header>
            <S.Content>
              <S.ModalContent>
                <S.InputsWrapper>
                  <S.InputContainer>
                    <S.Label>Nome da categoria</S.Label>
                    <S.Input
                      value={newSegment}
                      onChange={(event) => setNewSegment(event.target.value)}
                      readOnly={modalType === 'addCategoryExercise'}
                    />
                  </S.InputContainer>

                  {modalType === 'addCategoryExercise' && (
                    <S.InputContainer>
                      <S.Label>Nome do exercício</S.Label>
                      <S.Input
                        value={newExercise}
                        onChange={(event) => setNewExercise(event.target.value)}
                      />
                    </S.InputContainer>
                  )}

                  {isRegisteringExercise && (
                    <>
                      <S.InputContainer>
                        <S.Label>Adicionar vídeo</S.Label>
                        <label>
                          <S.InputRadio
                            type="radio"
                            checked={!addVideo}
                            onClick={() => setAddVideo(false)}
                          />{' '}
                          Não
                        </label>

                        <label>
                          <S.InputRadio
                            type="radio"
                            checked={addVideo}
                            onClick={() => setAddVideo(true)}
                          />{' '}
                          Sim
                        </label>
                      </S.InputContainer>

                      {addVideo && (
                        <>
                          <S.InputContainer>
                            <S.Label>
                              <p>Link do vídeo</p>
                              <BiVideo />
                            </S.Label>

                            <S.Input
                              value={videoUrl}
                              placeholder="https://www.youtube.com/"
                              onChange={handleInputChange}
                              // onChange={(e) => setVideoUrl(e.target.value)}
                            />
                          </S.InputContainer>

                          <S.InputContainer>
                            <S.LabelContainer>
                              <S.Label>Descrição</S.Label>
                              <p>{videoDescription.length} / 1000</p>
                            </S.LabelContainer>
                            <S.TextArea
                              rows={6}
                              value={videoDescription}
                              maxLength={1000}
                              onChange={(e) =>
                                setVideoDescription(e.target.value)
                              }
                            />
                          </S.InputContainer>
                        </>
                      )}
                    </>
                  )}
                </S.InputsWrapper>

                <Button
                  textContent="Criar"
                  variant="yellow"
                  onClick={handleClick}
                  textFont="13px"
                  extraStyles={{ height: '35px' }}
                />
              </S.ModalContent>
            </S.Content>
          </S.Container>
        </S.BackdropContainer>
      </>
    );
  },
);
